/*
 * ETCH v2 — "Change engraving" on cart lines (cart drawer and cart page).
 *
 * Line item properties are part of a line's identity, so adding the same piece again with a new
 * mark creates a second engraved line and the old one stays in the cart. This removes the line
 * first (POST cart/change, quantity 0), then opens the piece so it can be added again.
 *
 * - Delegated on document: the drawer and cart page re-render their lines through the Section
 *   Rendering API, so listeners on the links themselves would be lost.
 * - Loaded from snippets/cart-drawer.liquid and sections/main-cart-items.liquid; the guard below
 *   makes the second copy a no-op.
 * - Modified clicks (new tab or window) keep the plain link and remove nothing.
 * - If the request fails, the link is still followed (the old line stays, as without JS).
 * - The previous mark is handed to the product page in sessionStorage under
 *   "etch:change-engraving" as {variantId, quantity, engraving, at}, never in the URL, so the
 *   mark (often a name or a date) stays out of analytics and server logs.
 *
 * Also keeps the cart page head count ("02 PIECES", [data-etch-cart-count]) current: after a
 * quantity change cart.js re-renders only the line table and the footer, then publishes the new
 * cart state. Updates without a cart state (product form) re-render the whole <cart-items>.
 */
(function () {
  if (window.etchCartEdit) return;
  window.etchCartEdit = true;

  var STORAGE_KEY = 'etch:change-engraving';

  function piecesLabel(count) {
    return (count < 10 ? '0' : '') + count + (count === 1 ? ' piece' : ' pieces');
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = event && event.cartData ? event.cartData.item_count : undefined;
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-etch-cart-count]').forEach(function (node) {
        node.textContent = piecesLabel(count);
      });
    });
  }

  function changeUrl() {
    var base = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return base.replace(/\.js$/, '') + '.js';
  }

  function remember(link) {
    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          variantId: link.getAttribute('data-variant-id') || '',
          quantity: parseInt(link.getAttribute('data-quantity'), 10) || 1,
          engraving: link.getAttribute('data-engraving') || '',
          at: Date.now(),
        })
      );
    } catch (error) {
      /* storage blocked (private mode, policy): the flow works without it */
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('a.etch-line__edit[data-line-key]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('aria-busy', 'true');

    var href = link.href;
    remember(link);

    fetch(changeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: link.getAttribute('data-line-key'), quantity: 0 }),
    })
      .catch(function () {
        /* network error: fall through and follow the link */
      })
      .then(function () {
        window.location.assign(href);
      });
  });
})();
